import { Header } from './Header';
import { Typography } from './Typography';
import { Button } from './Button';
import { Wrapper } from './Wrapper';
import { ClientStrip } from './ClientStrip';
import styles from './HeroSection.module.css';
export function HeroSection() {
  return (
    <section className={styles.hero}>
      <img
        className={styles.image}
        src="/images/audit-architecture.webp"
        alt=""
        fetchPriority="high"
      />
      <div className={styles.overlay} />
      <Header inverse />
      <div className={styles.content}>
        <Typography variant="intro" tone="inverse">
          Независимый взгляд. Точные данные.
        </Typography>
        <Typography as="h1" variant="hero" tone="inverse">
          Аудит и инвентаризация для уверенных решений
        </Typography>
        <div className={styles.description}>
          <Typography tone="inherit">
            Проверяем отчётность и активы промышленных предприятий. Помогаем видеть реальное
            положение дел — по всему Казахстану.
          </Typography>
        </div>
        <Wrapper justify="center">
          <Button href="/contact/" variant="light">
            Связаться
          </Button>
          <Button href="/cases/" variant="secondary">
            Наши проекты
          </Button>
        </Wrapper>
      </div>
      <div className={styles.clients}>
        <ClientStrip inverse />
      </div>
    </section>
  );
}
